module.exports = __webpack_public_path__ + "img/card_menu_icon.496f830f.svg";